var map = {
	"./address.png": "f93c",
	"./alipay.png": "9a4f",
	"./boxNumber.png": "534e",
	"./branch.png": "3986",
	"./circle1.png": "9cd9",
	"./circle2.png": "a73d",
	"./clock.png": "c279",
	"./express.png": "fd26",
	"./flypay.png": "4015",
	"./icon_done_right.png": "35e5",
	"./icon_done_wrong.png": "1e4b",
	"./location.png": "508f",
	"./navigation.png": "61d9",
	"./paybill.png": "39dd",
	"./phone.png": "f713",
	"./plane.png": "1ecb",
	"./post.png": "309c",
	"./ship.png": "b28a",
	"./truck.png": "a478",
	"./user.png": "f2f6",
	"./volume.png": "d25a",
	"./wbNumber.png": "5f50",
	"./wechat.png": "fc51",
	"./weight.png": "2953"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ac1";